<div data-testid="usage-activity" class="usage-activity">
  <header class="usage-activity__header">
    <div class="usage-activity__titles">
      <h4 class="usage-activity__title">{{ cardTitle }}</h4>
      <p class="usage-activity__description">{{ description }}</p>
      <p *ngIf="numbersText" data-testid="usage-activity-numbers" class="usage-activity__numbers">{{ numbersText }}</p>
    </div>
  </header>
  <app-admin-dashboard-empty *ngIf="failed" data-testid="usage-activity-failed" icon="fa-regular fa-circle-exclamation"
                             [title]="failedTitle" body="Try again, or pick another period." [compact]="true"></app-admin-dashboard-empty>
  <app-admin-dashboard-empty *ngIf="loaded && !failed && isEmpty" data-testid="usage-activity-empty" icon="fa-regular fa-chart-line"
                             [title]="emptyTitle"></app-admin-dashboard-empty>
  <div *ngIf="loaded && !failed && !isEmpty" #chart data-testid="usage-activity-chart" class="usage-activity__chart"></div>
  <div *ngIf="!loaded" class="usage-activity__chart"></div>
  <p *ngIf="loaded && !failed && !isEmpty && historyText" data-testid="usage-activity-history" class="usage-activity__note">{{ historyText }}</p>
</div>
